<template>
  <header>
    <p>ヘッダー</p>
  </header>
</template>

<script>
export default {
  data() {},
}
</script>
